<template>
  <div class="col-lg-6 col-md-12 col-xs-12 d-md-block d-none">
    <div class="imagecard">
      <img src="https://cdn.proxyscrape.com/img/how_network_works.png" alt="How the residential network works">
    </div>
  </div>
  <div class="col-lg-6 col-md-12 col-xs-12">
    <div class="textcard">
      <h2>How residential proxies work</h2>
      <br>
      <p>With our 7 million IP proxy network, you will be sure to get the best results possible.
        When you connect to our proxy endpoint, we will forward your request to one of our
        available proxies in our pool within the desired country you selected. In comparison to
        direct connections to proxies, our proxy endpoint ensures the best possible speeds when
        connecting through it, carefully selecting the proxy to which your request is forwarded.
      </p>
      <a
        href="#pricing"
        style="font-weight: 600; text-decoration: none;">
        See pricing
        <img alt="" src='@/assets/img/svg/right-arrow.svg' style="height: 14px;">
      </a>
    </div>
  </div>
  <div class="col-lg-6 col-md-12 col-xs-12 d-md-none d-block">
    <div class="imagecard">
      <img src="https://cdn.proxyscrape.com/img/how_network_works.png" alt="How the residential network works">
    </div>
  </div>
</template>

<script setup lang='ts'>
</script>

<style scoped>

</style>
